import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class LoaderService {
	private status = new Subject<boolean>();
	public status_ = this.status.asObservable();

	display(value: boolean) {
		this.status.next(value);
	}
}
